export default __webpack_public_path__ + "static/media/tiny-temptress-logo.023a06fd.png";